export default {
  en: {
    languages: {
      language: 'Language',
      english: 'English',
      french: 'Français'
    },
    login: {
      email: 'Email',
      emailPlaceholder: 'Enter Email',
      password: 'Password',
      passwordPlaceholder: 'Enter password',
      login: 'Login'
    },
    nav: {
      dashboard: 'Dashboard',
      media: 'Media',
      chargers: 'Chargers',
      partners: 'Partner Programs',
      sky: 'Sky Objects',
      users: 'Users',
      reports: 'Reports',
      logout: 'Log Out'
    },
    labels: {
      search: 'Search',
      selectOne: 'select one',
      selectOption: 'Select option',
      cost: 'Cost',
      optional: 'optional',
      seconds: 'seconds'
    },
    buttons: {
      uploadMedia: 'Upload Media',
      viewMedia: 'View Media',
      editMedia: 'Edit Media',
      createReports: 'Create Reports',
      createMore: 'Create More',
      view: 'View',
      grid: 'Grid',
      table: 'Table',
      resume: 'Resume',
      edit: 'Edit',
      save: 'Save',
      savePublish: 'Save & Publish',
      saveFinish: 'Save & Finish',
      republish: 'Republish',
      delete: 'Delete',
      cancel: 'Cancel',
      done: 'Done',
      back: 'Back',
      continue: 'Continue',
      skipForNow: 'Skip for Now',
      skipSaveDraft: 'Skip & Save as Draft',
      finalReview: 'Final Review',
      saveUpload: 'Save & Upload',
      close: 'Close',
      revisit: 'Revisit',
      uploadMore: 'Upload More',
      noGoBack: 'No, Go Back',
      yesDelete: 'Yes, Delete'
    },
    dashboard: {
      liveMedia: 'Live Media',
      expiringSoon: 'Expiring Soon',
      goingLiveSoon: 'Going Live Soon',
      incomplete: 'Incomplete'
    },
    media: {
      sortBy: 'Sort by',
      name: 'Name',
      status: 'Status',
      goLiveDate: 'Go-Live Date',
      expirationDate: 'Expiration Date',
      expirationDateAbbr: 'Exp. Date',
      createdOn: 'Created on',
      createdBy: 'Created by',
      uploadTo: 'Upload to',
      chargers: 'Chargers',
      stations: 'Stations',
      states: 'States',
      zipCodes: 'Zip Codes',
      duration: 'Duration',
      cost: 'Cost',
      comments: 'Comments',
      preview: 'Preview',
      screen: 'Screen',
      screensaver: 'Screensaver',
      presentPayment: 'Present Payment',
      payment: 'Payment',
      thankYou: 'Thank You',
      audience: 'Audience',
      utility: 'Utility',
      deleteModal: 'Are you sure you want to delete this item?',
      warningModal: 'Editing this content will revert it to INCOMPLETE and will no longer be set to LIVE. You must complete the Review process and hit "Save and Republish" to ensure it is set back to LIVE. Are you sure you wish to continue?'
    },
    status: {
      incomplete: 'Incomplete',
      inQueue: 'In Queue',
      live: 'Live',
      archived: 'Archived'
    },
    charger: {
      screenID: 'Screen ID',
      city: 'City',
      screensInUse: 'Screens in Use'
    },
    users: {
      firstName: 'First Name',
      lastName: 'Last Name',
      role: 'Role',
      pending: 'Pending',
      assignRole: 'Assign Role',
      editRole: 'Edit Role',
      admin: 'Admin',
      editor: 'Editor',
      viewer: 'View Only'
    },
    reports: {
      title: 'Select which report(s) to create',
      subtitle: 'A separate report will be generated for each option selected.',
      allMedia: 'All Media',
      liveMedia: 'Live Media',
      archivedMedia: 'Archived Media',
      incompleteMedia: 'Incomplete Media',
      mediaByScreen: 'Media by Screen',
      mediaByPriority: 'Media by Priority',
      mediaByPartnerProgram: 'Media by Partner Program',
      mediaByChannel: 'Media by Channel (HMI, Portal, or Mobile App)',
      mediaByID: 'Media by Station ID, Charger ID, or Site Host/Enterprise',
      allChargers: 'All Chargers',

      doneTitle: 'Report created successfully! | Reports created successfully!',
      doneSubtitle: 'It should download automatically as a CSV. If not, you can | They should download automatically as a ZIP. If not, you can',
      doneDownloadAgain: 'download it again | download them again'
    },
    create: {
      platformTitle: 'Which platform are you uploading media to?',
      platformSubtitle: 'Are you uploading new default media for chargers?',
      platformDefaultLink: 'If yes, click here',
      platformPortal: 'Portal',
      platformMobileApp: 'Mobile app',
      titleHMI: 'Upload to HMI according to',
      nameTitle: 'Name these media',
      nameSubtitle: 'Names are only for this system and will not appear on the charger screens.',
      namePlaceholder: 'Type name here...',
      datesTitle: 'Set go-live and expiration dates',
      datesSubtitle: 'In San Francisco, if you schedule assets to go live on a Monday, they will go live at 12AM Pacific on that Monday.',
      datesGoLive: 'Go Live',
      datesExpire: 'Expire',
      datesExpireOptions: 'After {n} days',
      datesExpireSpecific: 'A specific date...',
      datesExpireNever: 'Never',
      detailsTitle: 'Enter additional details and upload media',
      detailsSubtitle: 'Allowable file types',
      detailsForgotCategory: 'Forgot a category?',
      detailsForgotAddMore: 'Go back and add more',
      detailsCommentsPlaceholder: 'This won\'t show up on the chargers...',
      uploadChooseFile: 'Choose file',
      uploadOnScreenPreview: 'On-Screen Preview (click to enlarge)',
      uploadCroppedSmall: 'Cropped image is too small and will be stretched.',
      uploadStandard: 'Standard',
      uploadWidescreen: 'Widescreen',
      reviewTitle: 'Give everything a final look',
      reviewSubtitle: 'All items highlighted in red must be fixed in order for media to be added to the go-live queue.',
      reviewUploadingTo: 'Uploading to',
      reviewNoTag: 'no tag | no tags',
      reviewNoName: 'no name',
      reviewNoGoLive: 'no go-live date',
      reviewNoExpire: 'no expiration date',
      reviewNoMedia: 'no media uploaded',
      doneTitleDefault: 'Default media uploaded successfully!',
      doneTitle: 'Media uploaded successfully!',
      defaultTitle: 'Upload default media for',
      defaultTitleCountry: 'Upload default media',
      defaultSubtitleUSA: 'These images will appear on ALL USA-BASED CHARGERS when no other images are assigned.',
      defaultSubtitleCanada: 'These images will appear on ALL CANADA-BASED CHARGERS when no other images are assigned.',
      hmiLocationTitle: 'Location',
      hmiPartnerTitle: 'Partner',
    },
    tags: {
      sitehost: 'Enterprise',
      // partners: 'Partner Programs',
      subscriptionPlan: 'Subscription Plan',
      state: 'State/Province',
      zip: 'ZIP/Postal Code',
      stationId: 'Location',
      chargerId: 'Station ID'
    },
    sky: {
      title: {
        'en-US': 'Edit the English US information',
        enDisabled: 'Review the English US information',
        'en-CA': 'Edit the English CA information',
        'fr-CA': 'Edit the French information',
        'es-MX': 'Edit the Spanish information',
        review: 'Give everything a final look'
      }
    }
  }
}